import React from 'react';
import { IconType } from 'react-icons';

interface SectionCardProps {
  title: string;
  icon?: IconType;
  children: React.ReactNode;
  className?: string;
}

export function SectionCard({ 
  title, 
  icon: Icon, 
  children, 
  className = '' 
}: SectionCardProps) {
  return (
    <div className={`bg-game-medium/20 border border-game-medium/30 rounded-lg p-4 ${className}`}>
      <h3 className="text-lg font-semibold text-white mb-4 pb-2 border-b border-game-medium/30 flex items-center gap-2">
        {Icon && <Icon className="text-game-golden" />}
        {title}
      </h3>
      {children}
    </div>
  );
}